import './header.css';

type HeaderProps = {
  level: number;
  color?: string;
}

function Header({ level, color = 'white' }: HeaderProps) {
  return (
    <h1 style={{ color }}>
      Level {level}
    </h1>
  )
}

export default Header;
